export enum StockMode {
    NONE = 0,
    CLOUD = 1,
    LOCAL = 2
}